// TODO: find out how to get this efficiently from the CSS (at build time?).
export const HEADER_HEIGHT_WITHOUT_SEARCH = 61;
export const HEADER_HEIGHT_WITH_SEARCH = 119;
